import { OnInit, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import LoadingService from 'src/app/services/loading.service';

@Component({
  selector: 'app-data-privacy',
  templateUrl: './data-privacy.component.html',
  styleUrls: ['./data-privacy.component.scss'],
  standalone: false
})
export default class DataPrivacyComponent implements OnInit {
  private loadingService = inject(LoadingService);
  private router = inject(Router);

  count = [1, 2, 3, 4];

  ngOnInit(): void {
    this.loadingService.stop();
  }

  refreshPage(): void {
    this.router.navigate(['/']);
  }
}
